import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Space, Table, TableProps } from "antd";
import { IoCodeSlash } from "react-icons/io5";
import useLoading from "../../../Hooks/useLoading";
import useModal from "../../../Hooks/useModal";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { ProjectGroupingModel } from "../../../Models/ProjectGroupingModel";
import { AuthContext } from "../../../Contexts/AuthContext";
import { deleteGroupingByIdAPI, getAllGroupingPaginatedByCompanyIdAPI, handleDownloadProjectGroupingModelAPI, handleUploadProjecGroupingtAPI } from "../../../API/ProjectGroupingAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { GetAllOpportunitiesMapping } from "../../../API/OpportunityMappingAPI";
import { OpportunityMappingModel } from "../../../Models/OpportunityMappingModel";
import { SortDesc } from "../../../Utils/SortYear";
import { SetFileName } from "../../../Utils/SetFileName";
import CardHeader from "../../components/CardHeader";
import './styles.css';
import PaginationTabs from "../../components/PaginationTabs";
import { CloudDownloadOutlined, CloudUploadOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import ModalDelete from "../../components/ModalDelete";
import ModalProjectGrouping from "./ModalCreateProjectGrouping";
import { UploadModal } from "../../components/UploadModal";

const ProjectsGrouping = () => {
    const { id } = useParams();
    const { toggleLoading, loading } = useLoading();
    const { showModal, toggleShowModal } = useModal();
    const { company } = useContext(CompanyContext);
    const [groupingList, setGroupingList] = useState<ProjectGroupingModel[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [idToDelete, setIdToDelete] = useState<string>("");
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [years, setYears] = useState<number[]>([]);
    const [yearSelected, setYearSelected] = useState<number>(0);
    const [menu, setMenu] = useState<string[]>(["Todos"]);
    const { showModal: isShowingExcelModal, toggleShowModal: toggleExcelModal } = useModal();
    const { showModal: isShowingDeleteModal, toggleShowModal: toggleDeleteModal } = useModal();
    const { userEmail } = useContext(AuthContext);
    const navigate = useNavigate();
    const take = 7;

    const deleteGroupingById = async (id: string) => {
        try {
            toggleLoading(true);

            await deleteGroupingByIdAPI(id, company.id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setIdToDelete("");
                    setItemToDelete("");
                    toast.success("Agrupamento deletado com sucesso!");
                    getAllGroupingPaginatedByCompanyId(1, 0);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getAllGroupingPaginatedByCompanyId = async (page: number, year: number) => {
        try {
            toggleLoading(true);

            var text = "\"\"";

            await getAllGroupingPaginatedByCompanyIdAPI(company.id, page, take, text, year == 0 ? "all" : year.toString()).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setGroupingList(resp.data.items);
                    setTotal(resp.data.total);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getYears = async () => {
        try {
            toggleLoading(true);

            await GetAllOpportunitiesMapping(company.id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var infos = resp.data as OpportunityMappingModel[];
                    var yearsData = infos.map((x) => { return x.year });
                    var length = yearsData.length;
                    var all = ["Todos"];
                    if (length > 0) {
                        yearsData = SortDesc(yearsData);
                        for (var i = 0; i < length; i++) {
                            all.push(yearsData[i].toString());
                        }
                    }
                    setMenu(all);
                    setYears(yearsData);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }
    async function massiveDownload() {
        toggleLoading(true);
        try {
            await handleDownloadProjectGroupingModelAPI(company.id).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    "download",
                    SetFileName(
                        company.name,
                        yearSelected.toString(),
                        "Agrupamento e Projetos",
                        "xlsx"
                    )
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                toast.success("Download Concluído! :)");
            });


        } catch (err: any) {
            toast.error(err);
        } finally {
            toggleLoading(false);
        }
    }
    async function handleUploadProjectGrouping(file: Blob[]) {
        try {
            toggleLoading(true);
            toggleExcelModal();
            if (file.length > 0) {
                await handleUploadProjecGroupingtAPI(file[0], company.id, userEmail).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        toast.success("Upload do Excel Concluído! :)");
                    }
                });
            }
        }
        catch (err: any) {
            toast.error(err);
        }
        finally {
            toggleLoading(false);
        }
    }

    function tabChanged(key: string) {
        let year = menu[parseInt(key)] != "Todos" ? parseInt(menu[parseInt(key)]) : 0;
        setYearSelected(year);
        getAllGroupingPaginatedByCompanyId(1, year);
    }

    function goTo(idRow: string) {
        navigate(`/projectGrouping/${id}/${idRow}`)
    }

    function deleteRow(idRow: string, name: string) {
        setIdToDelete(idRow);
        setItemToDelete(name);
        toggleDeleteModal();
    }

    function responseModalDelete(resp: boolean) {
        if (resp) {
            deleteGroupingById(idToDelete);
        } else {
            setIdToDelete("");
            setItemToDelete("");
        }
    }

    useEffect(() => {
        getYears();
        getAllGroupingPaginatedByCompanyId(1, 0);
    }, []);

    const ProjectsGroupingColumns: TableProps<ProjectGroupingModel>['columns'] = [
        {
            key: "name",
            dataIndex: "name",
            showSorterTooltip: { target: 'full-header' },
            filters: groupingList.map(item => ({
                text: item.name,
                value: item.name,
            })),
            onFilter: (value, record) => record.name.indexOf(value as string) === 0,
            title: "Agrupamento de Projetos",
            width: '50%'
        },
        {
            key: "groupNumber",
            dataIndex: "groupNumber",
            showSorterTooltip: { target: 'full-header' },
            title: "Nº Agrupamento",
            sorter: (a, b) => a.groupNumber - b.groupNumber,
            sortDirections: ['descend', 'ascend'],
        },
        {
            key: "totalBudget",
            dataIndex: "totalBudget",
            title: "Orçamento Total",
            showSorterTooltip: { target: 'full-header' },
            render: (value, row, index) => {
                return <span>R$ {value.toLocaleString('pt-BR')}</span>;
            },
            sorter: (a, b) => a.totalBudget - b.totalBudget,
            sortDirections: ['descend', 'ascend'],
        },
        {
            key: "name",
            dataIndex: "name",
            title: "Ações",
            width: '10%',
            render: (_, record) => (
                <Space size="small">
                    <Button type="text" size="small" onClick={() => goTo(record.id)}><EyeOutlined className="blue" /></Button>
                    <Button type="text" size="small" onClick={() => deleteRow(record.id, record.name)}><DeleteOutlined className="red-delete" /></Button>
                </Space>
            ),
        },
    ];

    return (
        <div className='card ms-2 me-2'>
            <CardHeader
                pageName="Agrupamento de Projetos"
                hasPageBefore={false}
            />
            <div className='card-body'>
                <div className="mb-2 w-100 position-relative pt-2">
                    <div className="d-flex align-items-center justify-content-end buttons-download-upload">
                        <Button
                            color="primary"
                            icon={<CloudDownloadOutlined />}
                            onClick={massiveDownload}
                            className='me-2'
                            variant="outlined"
                        >
                            Download Massivo
                        </Button>
                        <Button
                            color="primary"
                            icon={<CloudUploadOutlined />}
                            onClick={() => toggleExcelModal()}
                            className='ms-2'
                            variant="outlined"
                        >
                            Upload Massivo
                        </Button>
                    </div>
                    <PaginationTabs onChange={tabChanged} tabs={menu} />
                </div>

                <Table
                    loading={loading}
                    rowKey="id"
                    pagination={{
                        total: total,
                        pageSize: take,
                        onChange: (page, pageSize) => {
                            getAllGroupingPaginatedByCompanyId(page, yearSelected);
                        },
                    }}
                    dataSource={groupingList}
                    columns={ProjectsGroupingColumns}
                />

                <Button type="primary" className="w-100 mt-3" onClick={toggleShowModal}>Novo Agrupamento</Button>
            </div>
            <ModalDelete
                show={isShowingDeleteModal}
                toggleShow={toggleDeleteModal}
                setResponse={responseModalDelete}
                itemName={`agrumento: ${itemToDelete}`}
            />
            <ModalProjectGrouping
                getAllGroupingPaginatedByCompanyId={getAllGroupingPaginatedByCompanyId}
                showModal={showModal}
                toggleLoading={toggleLoading}
                toggleShowModal={toggleShowModal}
                years={years}
            />
            <UploadModal
                action={handleUploadProjectGrouping}
                icon={IoCodeSlash}
                isShowing={isShowingExcelModal}
                toggle={toggleExcelModal}
                acceptTypes={[".xlsx"]}
                isMultiple={false}
            />
        </div>
    )
}

export default ProjectsGrouping;